import { NoDataAvailable } from "@pmag/ui-components";
import { type GQLComponentGroupWPArticleFragment } from "@src/graphql.generated";
import { WPArticleGrid } from "@src/pages/componentGroupOverview/components/wpArticleGrid/WPArticleGrid";
import { WPArticleGridSkeleton } from "@src/pages/componentGroupOverview/components/wpArticleGrid/WPArticleGridSkeleton";
import { type FunctionComponent, useMemo } from "react";

export const dataTestId = {
    loadingSkeleton: "sparePartsFinder.componentGroupOverview.wpTab.loadingSkeleton",
    InlineError: "sparePartsFinder.componentGroupOverview.wpTab.InlineError",
    NoDataAvailable: "sparePartsFinder.componentGroupOverview.wpTab.NoDataAvailable",
};

export interface WPPartsTabProps {
    data: GQLComponentGroupWPArticleFragment[];
    loading: boolean;
    searchTerm: string;
}

export const WPPartsTab: FunctionComponent<WPPartsTabProps> = ({ searchTerm, data, loading }) => {
    const filteredCompatibleWPArticles = useMemo(() => {
        if (searchTerm != "" && data.length > 0) {
            return data.filter((article) => article.description?.toLowerCase().includes(searchTerm.toLowerCase()));
        }

        return data;
    }, [data, searchTerm]);

    if (loading) return <WPArticleGridSkeleton data-testid={dataTestId.loadingSkeleton} />;

    if (filteredCompatibleWPArticles.length === 0) return <NoDataAvailable data-testid={dataTestId.NoDataAvailable} />;

    return <WPArticleGrid articles={filteredCompatibleWPArticles} />;
};
